/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CurrentlyWorkingDto { 
    attendanceId?: number;
    clockIn?: string;
    clockInMethod?: string;
    durationMinutes?: number;
    nfcCardId?: string;
    staffId?: number;
    staffName?: string;
    staffNo?: string;
}

